import React, {useState} from "react"
import './ModalForm.css'
import './ModalFormCombustible.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFunnelDollar, faGasPump } from "@fortawesome/free-solid-svg-icons";

export const ModalFormCombustible = ({setShowModalCombustible, activoName, handleMinimizarModalCombustible, minimizar}) => {

    const [combustibleSelected,setCombustibleSelected] = useState(null);

    return <div className="modalFormDiv modalCombustibleContainer">
        <button className="minimizarBtn" onClick={()=>minimizar(false)}>X</button>
        <div className="bodyModalForm combustibleContainer">
            <h4 className="headerCombustible">Seleccione la cantidad de combustible actual para <label className="activoNameLabel">{activoName}</label></h4>
            <div className="combustibleSelectContainer">
                <div className="graphicFuelDisplay"  style={{borderColor: combustibleSelected == 0.1 ? 'red' : '#3d4d87'}}>
                   <div className="progressBar" style={{height: `${combustibleSelected * 100}%`, backgroundColor: combustibleSelected == 0.1 ? 'red' : '#3d4d87'}}></div>
                   {/* <div className="progressBar" style={{height: (400 * combustibleSelected), backgroundColor: combustibleSelected == 0.1 ? 'red' : '#3d4d87'}}></div> */}
                </div>
                <FontAwesomeIcon icon={faGasPump} style={{alignSelf:'center', fontSize:40}}/>
                <div className="fuelSelectorContainer">
                    <button className={`solapaBtn`} onClick={()=>setCombustibleSelected(1)} >1</button>
                    <button className={`solapaBtn`} onClick={()=>setCombustibleSelected(0.75)} >3/4</button>
                    <button className={`solapaBtn`} onClick={()=>setCombustibleSelected(0.5)} >1/2</button>
                    <button className={`solapaBtn`} onClick={()=>setCombustibleSelected(0.25)} >1/4</button>
                    <button className={`solapaBtn ${combustibleSelected == 'Reserva' ? 'selected' : ''}`} onClick={()=>setCombustibleSelected(0.1)} >Reserva</button>
                </div>
            </div>
            <button onClick={()=>handleMinimizarModalCombustible(combustibleSelected)} className="saveBtn">guardar</button>
        </div>
    </div>

}
